module.exports = __webpack_public_path__ + "img/order_icon.476db2b3.svg";